import type { DashboardDto } from "@stryker/core/types/dashboard";
import { useConfigOptions } from "@/hooks/useConfigOptions";

import LineChartComponent from "./charts/LineChart";

type QuotesAndRevenuesProps = {
  graphsData?: DashboardDto["revenuesCost"];
};

export default function QuotesAndRevenues({ graphsData }: QuotesAndRevenuesProps) {
  const { allKits } = useConfigOptions();

  return (
    <div className="flex flex-wrap gap-8 p-4">
      <LineChartComponent
        data={graphsData?.revenueByRepairSystem ?? []}
        dataKey="repairSystem"
        title="Revenue/quotes by Repair System"
        lines={[
          { lineName: "Revenue", lineDataKey: "revenue", color: "blue" },
          { lineName: "Quote", lineDataKey: "quote", color: "red" },
        ]}
      />

      <LineChartComponent
        data={graphsData?.revenueByBranch ?? []}
        dataKey="branch"
        title="Revenue/quotes by branch"
        lines={[
          { lineName: "Revenue", lineDataKey: "revenue", color: "blue" },

          { lineName: "Quote", lineDataKey: "quote", color: "red" },
        ]}
      />

      <LineChartComponent
        data={graphsData?.revenueByPlant ?? []}
        dataKey="plant"
        title="Revenue/quotes by plant"
        lines={[
          { lineName: "Revenue", lineDataKey: "revenue", color: "blue" },

          { lineName: "Quote", lineDataKey: "quote", color: "red" },
        ]}
      />

      <LineChartComponent
        data={graphsData?.revenueByPerson ?? []}
        dataKey="person"
        title="Revenue/quotes by person"
        lines={[
          { lineName: "Revenue", lineDataKey: "revenue", color: "blue" },

          { lineName: "Quote", lineDataKey: "quote", color: "red" },
        ]}
      />

      <LineChartComponent
        data={
          graphsData?.revenueByKitsSize.map((v) => {
            const kitLabel = allKits.find((k) => String(k.value) === String(v.kitsSize));

            return { ...v, label: kitLabel?.title ?? v.kitsSize };
          }) ?? []
        }
        dataKey="label"
        title="Revenue/quotes by kits Size"
        lines={[
          { lineName: "Revenue", lineDataKey: "revenue", color: "blue" },

          { lineName: "Quote", lineDataKey: "quote", color: "red" },
        ]}
      />
    </div>
  );
}
